import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getProfileCardWidgetStyles = props => {
  var avatarImageUrl = props.avatarImageUrl;
  return StyleSheet.create({
    topContainer: {
      flexDirection: 'row',
      justifyContent: avatarImageUrl ? 'space-between' : 'flex-end',
      alignItems: 'center'
    },
    rightContainer: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    bottomContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: tokens.spacing.SPACING_12
    },
    linkListItemWidgetStyle: {
      marginTop: tokens.spacing.SPACING_4
    },
    chatButtonStyle: {
      paddingLeft: tokens.spacing.SPACING_4
    },
    settingStyle: {
      paddingLeft: tokens.spacing.SPACING_12
    }
  });
};